export default "__VITE_ASSET__DfNUanrJ__"